import { inject, Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { CurrentStateService } from "src/app/core/services/current-state.service";

/**
 * Controls access to the setup routes.
 * Allows access only if the setup is incomplete, otherwise it redirects to the dashboard.
 */
@Injectable({
	providedIn: "root",
})
export class SetupCompleteGuard implements CanActivate {
	private router = inject(Router);
	private state = inject(CurrentStateService);

	canActivate(): UrlTree | boolean | Observable<UrlTree | boolean> {
		return this.state.getCurrentState().pipe(
			map((state) => {
				if (state.school.setupCompleted) {
					return this.router.createUrlTree([""]); // Redirect user to the dashboard.
				}
				return true; // Allow access to the setup routes
			}),
		);
	}
}
